// check the use cases first while using regex, update if needed
export const Validators = {
  EMAIL_REGEXP: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/,
  PINCODE_REGEX: /^\d{6}$/,

  OTP_REGEX: /^\d{6}$/,
  PHONE_REGEX: /^[6-9]\d{9}$/,
  NAME_REGEX: /^[A-Za-z .-]{1,40}$/,
  TIN_REGEX: /^[0123]{1}[0-9]{1}d{9}$/,
  AADHAR_REGEX: /^[0-9]{4}[ ]?[0-9]{4}[ ]?[0-9]{4}$/,
  PAN_REGEX: /^[A-Z]{3}[P]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}/,
  GSTIN_OR_TIN_REGEX: /(^[0-3][0-9]d{9}$|^[0-3][0-9]w{13}$)/,
  GSTIN_REGEX: /^([0][1-9]|[1-2][0-9]|[3][0-7])\w{13}$/,
    // /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/i,
  ACCOUNTNUMBER_REGEX: /^(?:[A-Za-z]*[0-9])w{8,18}$/,
  IFSC_REGEX: /^[A-Z]{4}d{7}$/,
  ONLY_SPACE: /.*S.*/,
};
